import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetRoomDetailsForEditRoomData, IGetRoomDetailsForEditRoomVars } from '../types';

export const GET_ROOM_DETAILS_FOR_EDIT_ROOM: TypedDocumentNode<
  IGetRoomDetailsForEditRoomData,
  IGetRoomDetailsForEditRoomVars
> = gql`
  query getRoom($input: ReadRoomInput!) {
    readRoom(input: $input) {
      id
      capacity
      created
      groupTypes
      joinCode
      status
      staff {
        active
        confirmed
        email
        firstName
        id
        lastName
        phone
        role
        welcomed
      }
      startPin
      students {
        absent
        checkedInCenter
        deniedEntry
        groupType
        id
      }
      title
      updated
    }
  }
`;
